export default __webpack_public_path__ + "static/media/blog_img1.3227a5ed.png";